import cn from 'classnames';
import moment from 'jalali-moment';

import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {shortenString} from '../../../../utilities/helper/shortenString';
import RateStarBadge from '../../../RateStarBadge';

const ShopDetailsAdvertisementsCard = ({
  id,
  title,
  state,
  city,
  main_image,
  status,
  cardWrapperClassName,
  store,
  immediate,
  discount_price,
  ad_price,
  discount_amount,
  has_discount,
  created_at,
  sub_brand_main_image,
  cardSize = 'md',
  onClick,
}: PrimaryCardProps) => {
  const today = new Date();
  const dateTime = moment(moment(new Date(created_at)))
    .locale('fa')
    .from(today); // "a day ago"

  return (
    <div className="flex w-full" key={id} onClick={onClick}>
      <div
        className={cn(
          '!h-[112px] w-[296px] px-2 py-2.5 gap-2 bg-white items-center flex rounded-[8px] shadow-sm',
          cardWrapperClassName,
        )}
      >
        <div className={cn('!h-[88px] !w-[88px] flex relative rounded-[8px]')}>
          <img
            className={cn('flex w-full h-full rounded-[8px] object-cover')}
            src={
              (main_image?.image_128 || sub_brand_main_image?.image) ??
              'https://s3.ir-thr-at1.arvanstorage.ir/shop-advertisement/empty_card_image.svg'
            }
            alt={title}
          />
        </div>
        <div className="flex flex-col justify-between flex-1 h-full">
          <div className="flex flex-col justify-between flex-1 text-md gap">
            <div className="flex flex-col">
              <span className="mb-2">{shortenString(title, 4)}</span>
              {store && store?.rate > 0 && (
                <div className="flex justify-between gap-2">
                  <div className="flex items-center text-gray-700">
                    <i className="text-lg icon-nameStore1"></i>
                    <span className="line-clamp-1">{store?.title}</span>
                  </div>
                  <RateStarBadge rate={store?.rate} />
                </div>
              )}
              {!store && state && (
                <div className="flex items-center text-sm text-gray-700">
                  <SpanIcon className="icon-nameLocation1 ml-0.5" />
                  <span>
                    {state?.name}, {city?.name}
                  </span>
                </div>
              )}
            </div>
            <div className="text-sm text-gray-700">
              {immediate && (
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-0.5">
                    <i className="icon-nameSpeaker-megaphone" />
                    <span>فوری</span>
                  </div>
                  <div>
                    {RenderPrice({
                      discount_price,
                      ad_price,
                      discount_amount,
                      has_discount,
                    })}
                  </div>
                </div>
              )}
              {status === 'rejected' && (
                <div className="flex justify-between">
                  <span className="text-red-200">رد شده </span>
                  <div className="flex gap-2 ">
                    <span className="text-green-300">رفع نواقص</span>
                    <span className="text-red-200">حذف</span>
                  </div>
                </div>
              )}
              {status === 'pending' && (
                <div className="flex justify-between w-full">
                  <span className="text-red-200">در انتظار تایید</span>
                  {RenderPrice({
                    discount_price,
                    ad_price,
                    discount_amount,
                    has_discount,
                  })}
                </div>
              )}
              {status === 'published' && !immediate && (
                <div className="flex items-end justify-between flex-1">
                  <span className="flex">{dateTime}</span>
                  {RenderPrice({
                    discount_price,
                    ad_price,
                    discount_amount,
                    has_discount,
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopDetailsAdvertisementsCard;

const RenderPrice = ({
  discount_price,
  ad_price,
  discount_amount,
  has_discount,
}: IPriceProps) => {
  const originalPrice = Number(ad_price);
  const discountedPrice = Number(discount_price);
  const discountPercent = Number(discount_amount);

  const isValidPrice = (price: number) => Number.isFinite(price) && price > 0;

  const hasValidOriginalPrice = isValidPrice(originalPrice);

  const showDiscount =
    has_discount &&
    hasValidOriginalPrice &&
    isValidPrice(discountedPrice) &&
    discountedPrice < originalPrice &&
    Number.isFinite(discountPercent) &&
    discountPercent > 0;

  if (!hasValidOriginalPrice) {
    return null;
  }

  const finalPrice = showDiscount ? discountedPrice : originalPrice;

  const formatPrice = (price: number) => Math.round(price).toLocaleString();

  return (
    <div className="flex items-center text-xs text-gray-700">
      <div className="flex flex-col text-left">
        {showDiscount && (
          <span className="text-gray-500 line-through">
            {formatPrice(originalPrice)}
          </span>
        )}

        <div className="flex items-center gap-1">
          {showDiscount && (
            <div className="flex items-center justify-center h-5 px-2 text-white bg-red-500 rounded min-w-6">
              {discountPercent}%
            </div>
          )}

          <div className="flex items-center gap-1 text-black">
            <span className="font-medium text-md">
              {formatPrice(finalPrice)}
            </span>

            <span className="text-xs">تومان</span>
          </div>
        </div>
      </div>
    </div>
  );
};
